import React from "react";
import classes from "./Card.module.scss";
const Card= ({children, customClass}: {children: React.ReactNode, customClass?:string}) => {
  return <div className={`${classes.card} ${customClass}`}>{children}</div>;
};

export default Card;
